import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function Faq() {
  const { t } = useLang();
  const items = t("faq.items");

  return (
    <div className="tw-grid-bg min-h-screen pt-28 pb-24 sm:pt-32">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">{t("faq.title")}</h1>
          <p className="mt-4 text-base text-slate-500">{t("faq.subtitle")}</p>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
          {items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 px-5"
            >
              <AccordionTrigger className="py-5 text-left text-base font-semibold text-slate-900 hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-500">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
